import React, { useEffect } from 'react';
import styles from './Modal.module.css';

const Modal = ({ isOpen, onClose, onConfirm, title="", textConfirm="Подтвердить", textCancel="Отмена", children }) => {
    useEffect(() => {
        const handleEsc = (e) => {
            if (e.key === 'Escape') onClose();
        };
        document.addEventListener('keydown', handleEsc);
        return () => document.removeEventListener('keydown', handleEsc);
    }, [onClose]);

    // Блокировка скролла
    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }

        return () => {
            document.body.style.overflow = ''; // на случай размонтирования
        };
    }, [isOpen]);

    if (!isOpen) return null;

    return (
        <div className={styles.backdrop} onClick={onClose}>
            <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
                {title && (
                    <div className={styles.header}>
                        <h2>{title}</h2>
                    </div>
                )}
                <div className={styles.body}>{children}</div>
                <div className={styles.footer}>
                    <button className={"btn btn-brown-noLine col-12 col-md"} onClick={onConfirm}>{textConfirm}</button>
                    <button className={"btn btn-brown-noLine col-12 col-md"} onClick={onClose}>{textCancel}</button>
                </div>
            </div>
        </div>
    );
};

export default Modal;
